import i18n from 'i18next';
import { DisputeResponse } from './payments.types';
import { DateTime } from 'luxon';

export const generateCardSummary = data => {
  const cardSummary = [];

  if (data.cardSummary) {
    Object.entries(data.cardSummary.summary).forEach((item: any) => {
      cardSummary.push({
        id: item[0],
        header: item[0],
        count: item[1].count,
        amount: item[1].amountTotal,
        refunds: item[1].refundTotal,
        total: item[1].resultingTotal,
      });
    });

    cardSummary.push({
      id: 'TOTAL',
      header: i18n.t('TransactionsReport.cardSummaryGrid.row.total'),
      count: data.cardSummary.count,
      amount: data.cardSummary.amountTotal,
      refunds: data.cardSummary.refundTotal,
      total: data.cardSummary.resultingTotal,
    });
  }

  return cardSummary;
};

export const transformPaymentsReportsData = data => {
  return {
    lastDepositDate: data.lastDepositDate,
    transactions: [
      {
        id: 'TRANSACTIONS_AMOUNT',
        header: i18n.t(
          'TransactionsReport.transactionsGrid.row.transactionsAmount',
        ),
        count: data.transactionsCount,
        amount: data.transactionsTotal,
      },
      {
        id: 'REFUNDS',
        header: i18n.t('TransactionsReport.transactionsGrid.row.refunds'),
        count: data.refundsCount,
        amount: data.refundsTotal,
      },
      {
        id: 'COMPLETED_CHARGEBACKS',
        header: i18n.t(
          'TransactionsReport.transactionsGrid.row.completedChargebacks',
        ),
        count: data.completedChargebacksCount,
        amount: data.completedChargebacksTotal,
      },
      {
        id: 'PENDING_CHARGEBACKS',
        header: i18n.t(
          'TransactionsReport.transactionsGrid.row.pendingChargebacks',
        ),
        count: data.pendingChargebacksCount,
        amount: data.pendingChargebacksTotal,
      },
      {
        id: 'FEES',
        header: i18n.t('TransactionsReport.transactionsGrid.row.fees'),
        count: data.feesCount,
        amount: data.feesTotal,
      },
      {
        id: 'TOTAL_AMOUNT',
        header: i18n.t('TransactionsReport.transactionsGrid.row.totalAmount'),
        count: data.resultingCount,
        amount: data.resultingTotal,
      },
      {
        id: 'TOTAL_DEPOSITS',
        header: i18n.t('TransactionsReport.transactionsGrid.row.totalDeposits'),
        count: data.payoutsCount,
        amount: data.payoutsTotal,
      },
    ],
    cardSummary: generateCardSummary(data),
  };
};

const updateStatus = (dispute: DisputeResponse) => {
  const {
    stripeBody: {
      status,
      evidence_details: { due_by },
    },
  } = dispute;

  const isDeadlineMissed: boolean =
    Math.floor(DateTime.fromSeconds(due_by).diffNow('days').days) < 0;

  if (isDeadlineMissed) {
    if (status === 'needs_response') {
      return {
        ...dispute,
        stripeBody: {
          ...dispute.stripeBody,
          status: 'dispute_deadline_missed',
        },
      };
    }

    if (status === 'warning_needs_response') {
      return {
        ...dispute,
        stripeBody: {
          ...dispute.stripeBody,
          status: 'inquiry_deadline_missed',
        },
      };
    }
  }

  return dispute;
};

export const transformDisputesData = data => {
  return {
    ...data,
    paging: { ...data.paging },
    content: data.content.map(dispute => updateStatus(dispute)),
  };
};
